import React from 'react'
import '../CSS/style.css'
import '../CSS/responsive.css'




  


export default function Testimonials() {
    
    
  return (
    <>
    
    <br />
        <h1 className="p-heading">Testimonials</h1>
        <div className="testimonials flex m-auto">
            <div className="testimonial flex fd-col">
                <h2 className="name sec-heading">Sahil Kumar</h2>
                <div className="msg">I am very glad to launch <strong>UnlockCode</strong>. I hope you all should start coding and work with us so that we make a very powerful coding community together. Let's Code</div>
            </div>
            <div className="testimonial flex fd-col">
                <h2 className="name sec-heading">Harsh Sharma</h2>
                <div className="msg">I am very glad to join <strong>UnlockCode</strong> as Chief Programmer. I will make all the possible attempts so that you all get the best coding community here.</div>
            </div>
            <div className="testimonial flex fd-col">
                <h2 className="name sec-heading">Pawan Raj Singh</h2>
                <div className="msg">I am very glad to join <strong>UnlockCode</strong> as Assistant Programmer. I hope you all should connect and give us a chance to impress you.</div>
            </div>
        </div>
        <br />
    </>
  )
}
